import React, { useEffect, useRef } from 'react';
import '../styles/ModernFeaturesSection.css';

const ModernFeaturesSection = () => {
  const featuresRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const featureElements = document.querySelectorAll('.feature-card');
    featureElements.forEach((el, index) => {
      observer.observe(el);
      el.style.transitionDelay = `${index * 0.15}s`;
    });

    return () => {
      featureElements.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  const features = [
    {
      id: 1,
      title: 'Premium Quality Bikes',
      description:
        'Our fleet includes top-tier bikes from renowned brands, offering exceptional performance, comfort, and style for all your riding needs.',
      badge: 'Top Rated Fleet',
      accent: '#DAA520', // Golden yellow
      decorativeNumber: '01'
    },
    {
      id: 2,
      title: 'Competitive Rental Rates',
      description:
        'Enjoy the best value for your money with our affordable pricing plans, special discounts, and flexible rental options tailored to your schedule.',
      badge: 'Best Price Guarantee',
      accent: '#4A3728', // Dark brown
      decorativeNumber: '02'
    },
    {
      id: 3,
      title: 'Expertly Maintained Fleet',
      description:
        'Each bike undergoes rigorous safety checks and maintenance before every rental, ensuring a smooth, reliable, and worry-free riding experience.',
      badge: 'Safety Assured',
      accent: '#8B6B42', // Medium brown
      decorativeNumber: '03'
    },
    {
      id: 4,
      title: 'Modern Booking Experience',
      description:
        'Book your perfect bike in seconds with our intuitive mobile-friendly platform, featuring real-time availability, instant confirmations, and seamless payments.',
      badge: 'User-Friendly',
      accent: '#6B4226', // Darker brown
      decorativeNumber: '04'
    }
  ];

  return (
    <section className="features-container">
      <div className="section-title">
        <h2>
          Premium Biking <span className="highlight">Experience</span>
        </h2>
        <p>Discover why thousands of riders choose our bikes for their adventures</p>
      </div>

      <div className="features-grid">
        {features.map((feature) => (
          <div
            key={feature.id}
            className="feature-card fade-in-up"
            ref={(el) => (featuresRef.current[feature.id] = el)}
          >
            <div className="feature-decorative-elements">
              <div className="decorative-number" style={{ color: feature.accent }}>
                {feature.decorativeNumber}
              </div>
              <div className="dotted-line" style={{ borderColor: feature.accent }}></div>
              <div className="corner-accent" style={{ borderColor: feature.accent }}></div>
            </div>
            
            <div className="feature-content">
              <h3 className="feature-title" style={{ '--accent-color': feature.accent }}>
                {feature.title}
              </h3>
              <p className="feature-description">{feature.description}</p>
              <span className="feature-badge" style={{ backgroundColor: `${feature.accent}15`, color: feature.accent, borderColor: `${feature.accent}30` }}>
                {feature.badge}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ModernFeaturesSection;